import React from 'react';
import { useTranslation } from 'react-i18next';
import PageBanner from '../layout/PageBanner';

const TermsOfService = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageBanner parentPage="Home" activePage="Terms of Service" motherMenu="Terms of Service" />

            <section className="main-legal-content" style={{ background: '#ffffff', padding: '120px 0' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div style={{ marginBottom: '40px' }}>
                                <h1 style={{ fontSize: '36px', fontWeight: '700', color: '#2c3d4f', marginBottom: '20px' }}>
                                    Terms of Service
                                </h1>
                                <p style={{ color: '#5a6c7d', fontSize: '16px', marginBottom: '10px' }}>
                                    <strong>Last updated:</strong> {new Date().toLocaleDateString('en-GB')}
                                </p>
                            </div>

                            <div className="legal-content" style={{ color: '#5a6c7d', fontSize: '16px', lineHeight: '1.8' }}>
                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    1. Acceptance of Terms
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    By accessing and using Pure Key Homes' property management services, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    2. Service Description
                                </h2>
                                <p style={{ marginBottom: '15px' }}>Pure Key Homes provides comprehensive property management services including:</p>
                                <ul style={{ marginBottom: '20px', paddingLeft: '30px' }}>
                                    <li style={{ marginBottom: '10px' }}>Full property management and maintenance coordination</li>
                                    <li style={{ marginBottom: '10px' }}>Key holding and secure property access</li>
                                    <li style={{ marginBottom: '10px' }}>Guest check-in/check-out and communication</li>
                                    <li style={{ marginBottom: '10px' }}>Professional cleaning and laundry services</li>
                                    <li style={{ marginBottom: '10px' }}>Property inspections and reporting</li>
                                    <li style={{ marginBottom: '10px' }}>24/7 emergency response</li>
                                </ul>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    3. Client Responsibilities
                                </h2>
                                <p style={{ marginBottom: '15px' }}>As a client, you agree to:</p>
                                <ul style={{ marginBottom: '20px', paddingLeft: '30px' }}>
                                    <li style={{ marginBottom: '10px' }}>Provide accurate and complete information about your property</li>
                                    <li style={{ marginBottom: '10px' }}>Grant necessary access and permissions for service delivery</li>
                                    <li style={{ marginBottom: '10px' }}>Make timely payments for services rendered</li>
                                    <li style={{ marginBottom: '10px' }}>Maintain adequate property insurance</li>
                                    <li style={{ marginBottom: '10px' }}>Comply with all applicable laws and regulations</li>
                                </ul>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    4. Service Fees and Payment
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    Service fees are based on the specific services selected and property size. All fees will be clearly communicated before service commencement. Payment terms are typically monthly or per-service basis. Late payments may result in service suspension or additional fees.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    5. Service Agreement and Termination
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    Service agreements may be structured as ongoing or fixed-term contracts. Either party may terminate the service agreement with 30 days written notice. Early termination fees may apply depending on the contract terms. We reserve the right to terminate services immediately in case of non-payment or breach of terms.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    6. Liability and Insurance
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    Pure Key Homes maintains professional liability insurance. However, we are not liable for damage caused by circumstances beyond our control, including natural disasters, third-party actions, or pre-existing property conditions. Clients are responsible for maintaining their own property insurance.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    7. Emergency Services
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    Our 24/7 emergency response service is available for urgent property issues. Emergency service calls may incur additional fees depending on the nature and timing of the emergency. We will make reasonable efforts to respond promptly to all emergency situations.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    8. Confidentiality
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    We maintain strict confidentiality regarding all client information, property details, and access codes. Our staff are trained in data protection and security protocols.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    9. Changes to Terms
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    We reserve the right to modify these Terms of Service at any time. Changes will be communicated to clients via email or through our website. Continued use of our services after changes constitutes acceptance of the modified terms.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    10. Governing Law
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    These Terms of Service are governed by Spanish law. Any disputes will be subject to the jurisdiction of the courts of Murcia, Spain.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    11. Contact Information
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    For questions about these Terms of Service, please contact:
                                </p>
                                <p style={{ marginBottom: '5px' }}><strong>Email:</strong> info@pure-key-homes.es</p>
                                <p style={{ marginBottom: '5px' }}><strong>Phone:</strong> +34 614 005 838</p>
                                <p style={{ marginBottom: '20px' }}><strong>Address:</strong> Los Alcazares, Murcia, Spain</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default TermsOfService;
